export default {
  paymentSuccess: {
    event: "paymentSuccess",
    eventCategory: "Payment",
    eventAction: "Payment Button Click",
  },
  paymentFailure: {
    event: "paymentFailure",
    eventCategory: "Payment",
    eventAction: "Payment Button Click",
  },

  signUpView: {
    event: "signUp",
    eventCategory: "Page_View",
    eventAction: "PageView",
  },
  logInView: {
    event: "logIn",
    eventCategory: "Page_View",
    eventAction: "PageView",
  },
    forgotpasswordview: {
    event: "forgotPassword",
    eventCategory: "Page_View",
    eventAction: "PageView",
  },
  planView: {
    event: "plan",
    eventCategory: "Page_View",
    eventAction: "PageView",
  },
  checkoutView: {
    event: "checkout",
    eventCategory: "Page_View",
    eventAction: "PageView",
  },
  confirmationView: {
    event: "confirmation",
    eventCategory: "Page_View",
    eventAction: "PageView",
  },
  quizView: {
    event: "quiz",
    eventCategory: "Page_View",
    eventAction: "PageView",
  },
};
